import { TrainerDTO } from "@modules/shared/entities/users/users.entity";
import { useConfirmModal } from "@modules/shared/hooks/use-confirm-modal.hook";
import { useTrainers } from "@modules/trainers/hooks/use-trainers.hook";
import { TrainersService } from "@modules/trainers/services/trainers.service";
import { message } from "antd";
import { useState } from "react";
import { BsExclamationCircleFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

export default function AdSetting({ trainer }: { trainer: TrainerDTO | undefined }) {
    const [loading, setLoading] = useState(false);
    const { showConfirm } = useConfirmModal();
    const { deleteTrainer } = useTrainers();
    const navigate = useNavigate();

    const handleDeactivate = async () => {
        showConfirm(
            <div style={{ textAlign: 'center' }}>
                <BsExclamationCircleFill style={{ fontSize: 48, color: '#faad14', marginBottom: 16 }} />
                <h3 style={{ marginBottom: 8 }}>Deactice this trainer?</h3>
                <p style={{ marginBottom: 0 }}>This trainer will be lost.</p>
                <p style={{ fontSize: 13, color: '#888' }}>This action cannot be undone.</p>
            </div>,
            'Discard',
            'danger',
            async () => {
                try {
                    const trainersService = new TrainersService;
                    setLoading(true);

                    if (!trainer?.id) {
                        message.error('Not found trainer id !');
                        return;
                    }

                    const success = await deleteTrainer(trainer?.id);
                    if (success) {
                        message.success("Account deactivated successfully!");
                        navigate(-1);
                    } else {
                        message.error("Failed to deactivate account.");
                    }
                } catch (err) {
                    message.error("An error occurred while deactivating the account.");
                } finally {
                    setLoading(false);
                }
            }
        );
    };

    return (
        <div className="row border rounded p-3 mt-4" style={{ borderColor: "#f5c2c7" }}>
            <div className="col">
                <h6 className="fw-bold text-danger">Deactivate Account</h6>
                <p className="text-muted mb-3">
                    Once this account is deactivated, the user of this account will immediately lose access.
                    Please confirm before continuing.
                </p>
            </div>
            <div className="col d-flex justify-content-between align-items-center">
                <span></span>
                <button
                    type="button"
                    className="btn btn-outline-danger"
                    onClick={handleDeactivate}
                    disabled={loading}
                >
                    {loading ? "Deactivating..." : "Deactivate this account"}
                </button>
            </div>
        </div>
    );
}
